import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import mitt from 'mitt';
import 'element-plus/dist/index.css';
import '@/styles/global.css'; 

const app = createApp(App);

// 添加事件总线
const emitter = mitt();
app.config.globalProperties.$bus = emitter;

app.use(router);
app.use(store);
app.mount('#app');
